import { api } from '../services/api';
import { showToast } from '../utils/toast';

export async function promptPassphrase(classId: string, className: string): Promise<boolean> {
  // すでにセッションに保持されているか確認
  const stored = api.getStoredPassphrase(classId);
  if (stored) {
    const valid = await api.verifyPassphrase(classId, stored);
    if (valid) return true;
  }

  return new Promise((resolve) => {
    const modalRoot = document.getElementById('modal-root')!;
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay active';

    overlay.innerHTML = `
      <div class="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="passphrase-title">
        <div class="modal-header">
          <div class="modal-title" id="passphrase-title">
            <span>🔒</span>
            <span>提出パスフレーズの入力</span>
          </div>
        </div>
        <div class="modal-body">
          <p style="margin-bottom: 12px; color: var(--color-text-secondary); line-height: 1.5;">
            <strong>${className}</strong> の提出箱またはライブラリにアクセスするには、教員から案内された簡易パスフレーズを入力してください。
          </p>
          <div class="form-group">
            <label class="form-label" for="input-passphrase">
              パスフレーズ
              <span class="badge-req">必須</span>
            </label>
            <input
              type="password"
              id="input-passphrase"
              class="form-input"
              placeholder="例: nua2026 (デモ用: demo)"
              autocomplete="off"
            />
          </div>
          <p style="font-size: 11px; color: var(--color-text-tertiary); margin-top: 8px;">
            ※ 一度入力すると、ブラウザを閉じるまで再入力は不要です。
          </p>
        </div>
        <div class="modal-footer">
          <button id="btn-cancel-passphrase" class="btn btn-text" type="button">キャンセル</button>
          <button id="btn-submit-passphrase" class="btn btn-primary" type="button">認証して進む</button>
        </div>
      </div>
    `;

    modalRoot.appendChild(overlay);

    const input = overlay.querySelector('#input-passphrase') as HTMLInputElement;
    input.focus();

    const cleanup = () => {
      overlay.classList.remove('active');
      setTimeout(() => {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 200);
    };

    const handleVerify = async () => {
      const val = input.value.trim();
      if (!val) {
        showToast('パスフレーズを入力してください', 'error');
        return;
      }
      const valid = await api.verifyPassphrase(classId, val);
      if (valid) {
        showToast('パスフレーズを認証しました', 'success');
        cleanup();
        resolve(true);
      } else {
        showToast('パスフレーズが一致しません', 'error');
        input.select();
      }
    };

    overlay.querySelector('#btn-submit-passphrase')!.addEventListener('click', handleVerify);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') handleVerify();
    });

    overlay.querySelector('#btn-cancel-passphrase')!.addEventListener('click', () => {
      cleanup();
      resolve(false);
    });
  });
}
